<div class="wrapper">
    <h2 [ngClass]="titleClass"><span>{{ title }}</span><span class="icon icon-close" *ngIf="!loading" (click)="close()"></span></h2>
    <mat-dialog-content>
        <div *ngIf="!!icon" class="icon">
            <span [ngClass]="icon" [ngStyle]="{'color': iconColor}"></span>
        </div>
        <p [ngClass]="bodyClass" [innerHTML]="body | safeHtml "></p>
        <ng-template class="component-visual" #componentVisual></ng-template>
    </mat-dialog-content>
    <mat-dialog-actions *ngIf="!hideActionButtons">
        <button 
            [disabled]="loading" 
            [ngClass]="cancelButtonClass ? cancelButtonClass : 'bciti-inline-button'" 
            (click)="cancel()">
            {{ cancelLabel }}
        </button>
        <button 
        [disabled]="loading"
        class="bciti-button no-transition" 
        [ngClass]="confirmButtonClass" 
        (click)="confirm()">
            <span *ngIf="!loading">{{ confirmLabel }}</span>
            <span *ngIf="loading" class="loading-spinner">
                <mat-progress-spinner 
                    mode="indeterminate" 
                    diameter="20"
                ></mat-progress-spinner>
            </span>
        </button>
    </mat-dialog-actions>
</div>
